<template>
  <Form ref="form-address" class="bg-white p-8">
    <div class="w-full xl:w-11/12 m-auto">
      <p class="text-left text-2xl text-sm">Mon adresse de livraison</p>

      <div class="div-form">
        <InputText
          v-model="form.email"
          :required="true"
          label="Email"
          name="email"
          type="email"
          rules="required|email|max:50"
          :max="50"
          :errors="errors"
        />
        <InputSelect
          v-model="form.gender_id"
          :options="$store.genders"
          :required="true"
          label="Civilité"
          name="gender_id"
          rules="required"
          :errors="errors"
        />
      </div>

      <div class="div-form">
        <InputText
          v-model="form.last_name"
          :required="true"
          label="Nom"
          name="last_name"
          rules="required|max:21"
          :max="21"
          :errors="errors"
        />
        <InputText
          v-model="form.first_name"
          :required="true"
          label="Prénom"
          name="first_name"
          rules="required|max:16"
          :max="16"
          :errors="errors"
        />
      </div>

      <div class="div-form">
        <InputText
          v-model="form.address1"
          :required="true"
          label="Adresse"
          name="address1"
          rules="required|max:32"
          :max="32"
          :errors="errors"
        />
        <InputText
          v-model="form.address2"
          label="Complément d'adresse (optionnel)"
          name="address2"
          rules="max:32"
          :max="32"
          placeholder="Résidence, bâtiment, n° d'appartement, etc."
          :errors="errors"
        />
      </div>

      <div class="div-form">
        <InputText
          v-model="form.postal_code"
          :required="true"
          label="Code postal"
          name="postal_code"
          rules="required|max:5|min:5"
          :max="5"
          :errors="errors"
        />
        <InputSelect
          v-model="form.town"
          :options="towns"
          :required="true"
          label="Ville"
          name="town"
          rules="required|max:255"
          :errors="errors"
        />
      </div>

      <div class="div-form">
        <InputText
          v-model="form.landline_phone"
          :required="true"
          label="Téléphone"
          name="landline_phone"
          rules="required|max:13"
          :max="13"
          :errors="errors"
          @keydown.space.prevent
        />
        <InputText
          v-model="form.mobile_phone"
          label="Mobile"
          name="mobile_phone"
          rules="max:13"
          :max="13"
          :errors="errors"
          @keydown.space.prevent
        />
      </div>

      <div class="div-form">
        <InputText
          v-model="form.additionnal_info"
          label="Informations complémentaires"
          name="additionnal_info"
          rules="max:100"
          :max="100"
          as="textarea"
          class="!w-full"
          :errors="errors"
        />
      </div>

      <div class="text-left mt-4 text-grey">
        <span class="text-red font-bold">*</span> champs obligatoires
      </div>

      <div class="div-form flex flex-col">
        <Field
          v-slot="{ field }"
          :name="'rules'"
          type="checkbox"
          :value="true"
          :rules="'required'"
        >
          <label>
            <input
              :id="'rules'"
              type="checkbox"
              :name="'rules'"
              v-bind="field"
              :value="true"
            />
            <span class="text-red font-bold ml-2">Oui</span>, en validant mon
            numéro de participation ci-dessous, je déclare avoir lu et accepté
            les

            <span
              class="link"
              @click="
                openModal(
                  'Conditions Générales de Vente',
                  $template.conditions,
                  $template.conditions_picture
                )
              "
              >conditions générale de ventes</span
            >
            et le
            <span
              class="link"
              @click="
                openModal(
                  'Règlement Officiel de Jeu – Attribution soumise à aléas – À lire avec attention',
                  $template.rules,
                  $template.rules_picture
                )
              "
              >règlement de jeu</span
            >
            <span class="text-red font-bold"> * </span>
          </label>
        </Field>
        <ErrorMessage class="errorForm" :name="'rules'">
          <p class="text-red font-bold text-lg">Veuillez accepter les conditions de ventes et le règlement de jeu pour continuer</p>
        </ErrorMessage>
      </div>

      <div v-if="paypalErrors != ''" class="errorForm mt-2">
        {{ paypalErrors }}
      </div>

      <img src="@/assets/img/accepted-cards.jpg" alt="" class="m-auto mt-4">


      <div class="paypal-container mt-2 relative">
        <div id="paypal-button" class="paypal-button"></div>
        <button class="bg-red text-white p-2 rounded-lg w-full h-14 text-lg font-bold">Je valide ma commande</button>
      </div>
    </div>
  </Form>
</template>

<script>
import InputText from './Inputs/InputText.vue'
import InputSelect from './Inputs/InputSelect.vue'
import InputArea from './Inputs/InputArea.vue'
import { Form, Field, ErrorMessage } from 'vee-validate'
import router from '../../router'
// const PayPalButton = paypal.Buttons.driver("vue",Vue)

export default {
  components: {
    InputText,
    InputSelect,
    InputArea,
    ErrorMessage,
    Form,
    Field
    // "paypal-buttons": PayPalButton,
  },
  props: {},
  emits: ['openModal', 'openNotification'],
  data: () => ({
    errors: [],
    form: {},
    paypalErrors: '',
    towns : []
  }),
  created() {
    this.form = {
      email: this.$user.email.trim() ?? '',
      gender_id: this.$user.gender_id ?? '',
      last_name: this.$user.last_name ?? '',
      first_name: this.$user.first_name ?? '',
      town: this.$user.address.town ? this.$user.address.town[0].toUpperCase() + this.$user.address.town.slice(1).toLowerCase() : '',
      postal_code: this.$user.address.postal_code ?? '',
      address1: this.$user.address.address1 ?? '',
      address2: this.$user.address.address2 ?? '',
      landline_phone: this.$user.address.landline_phone ?? '',
      mobile_phone: this.$user.address.mobile_phone ?? '',
      additionnal_info: this.$user.address.additionnal_info ?? ''
    }

    let clientId = null
    if (window.location.href.includes('localhost') || window.location.href.includes('digiworks') || this.$user.is_test) {
      console.log('test')
      clientId =
      'AUzmJMkw_ik0v9qhTt7pVmL9v4nMHD4lfBpQFLbjKBZxTwsl6AY9a5lAar74mxaK-cmK1azaGup16U0M'
    } else {
      clientId =
      'AVfXETPnp536qAY_nzldk-MIEqhzFKt8KzAeVn76ladx1mxMJ99UJqwmxbt2Vkjpnxxl0sYKiWvGiod8'
    }

    const script = document.createElement('script')
    script.src = `https://www.paypal.com/sdk/js?client-id=${clientId}&locale=fr_FR&currency=EUR`
    script.addEventListener('load', this.paypalSetLoaded)
    document.body.appendChild(script)
  },
  methods: {
    openModal(title, message, img) {
      this.$emit('openModal', title, message, img)
    },
    paypalSetLoaded() {
      window.paypal
        .Buttons({
          style: {
            shape: 'pill',
            color: 'gold',
            layout: 'horizontal',
            label: 'paypal',
            tagline: false
          },
          onClick: this.paypalOnClick,
          createOrder: this.paypalCreateOrder,
          onApprove: this.paypalOnApprove,
          onShippingChange: this.paypalOnShippingChange,
          onError: this.paypalOnError
        })
        .render('#paypal-button')
    },
    async paypalOnClick(data, actions) {
      const validation = await this.$refs['form-address'].validate()
      if (!validation.valid) {
        return actions.reject()
      }

      try {
        const res = await this.$api.createAddress(
          this.$store.participation.id,
          this.form
        )
        if (res.status === 422) {
          this.errors = res.data.errors
          return actions.reject()
        }
        return actions.resolve()
      } catch (e) {
        console.log(e)
        return actions.reject()
      }
    },
    async paypalCreateOrder(data, actions) {
      try {
        const res = await this.$api.createPaypalTransaction(
          this.$store.participation.id
        , {isRecall2 : this.$store.recall2})
        return res.data.paypal_id
      } catch (e) {
        this.$emit(
          'openNotification',
          'Une erreur est survenue lors du traitement de votre commande. Veuillez réessayer ultérieurement.',
          true
        )
        console.log(e)
      }
    },
    async paypalOnApprove(data, actions) {
      try {
        await this.$api.approvePaypalTransaction(this.$store.participation.id)
        this.$store.setIsPayed(true)
        //purchase
        if (!window.location.href.includes('localhost') && !window.location.href.includes('digiworks')) {
          this.$gtm.trackEvent({
            event: "purchase", 
            campaignid : this.$campaign.code
          });
        }
        this.$router.push({ name: 'end' })
      } catch (e) {
        this.$emit(
          'openNotification',
          'Une erreur est survenue lors du traitement de votre paiement. Veuillez vérifier les informations de votre carte et réessayer.',
          true
        )
        console.log(e)
      }
    },
    paypalOnShippingChange: function () {
      return (data, actions) => {
        if (data.shipping_address.country_code !== 'FR') {
          return actions.reject()
        }
        return actions.resolve()
      }
    },
    paypalOnError: function () {
      return (err) => {
        console.error(err)
        this.paypalErrors = err
        // window.location.href = "/your-error-page-here";
      }
    }
  },
  watch: {
    // whenever question changes, this function will run
    async 'form.postal_code'(newValue) {
      if (newValue.length == 5) {
        const res = await this.$api.getTowns(newValue)
        if (res.data.length > 0 ) {
          this.towns = res.data 
          let userTown = this.$user?.address.town ? this.towns.find(town => this.$user.address.town.toUpperCase() == town.nom.toUpperCase()) : null
          if (userTown) {
            this.form.town = userTown.nom
          }
          this.errors = {
            postal_code : null
          }
        } else {
          this.errors = {
            postal_code : 
            {0 : 'Le code postal n\'est pas valide.'}
          }
        }
      } 
      else {
        this.errors = {
          postal_code : null
        }
      }
    }
  },
}
</script>

<style scoped>
.div-form {
  @apply lg:flex  w-full mt-3;
}

.input-form {
  @apply lg:w-1/2 lg:mr-4 mt-3 lg:mt-0;
}

.paypal-button {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1;
  opacity: .000001;
}
</style>
